module.exports = __webpack_public_path__ + "assets/facebook-dark.d1edaa9a.svg";